import { render, staticRenderFns } from "./Image.vue?vue&type=template&id=52098fe2&scoped=true&"
import script from "./Image.vue?vue&type=script&lang=js&"
export * from "./Image.vue?vue&type=script&lang=js&"
import style0 from "./Image.vue?vue&type=style&index=0&id=52098fe2&prod&scoped=true&lang=css&"
import style1 from "./Image.vue?vue&type=style&index=1&id=52098fe2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52098fe2",
  null
  
)

export default component.exports